import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import { Paging, User } from '@/store/models';
import store from '@/store';
import managerService from '@/services/common/manager.service';

@Module({ namespaced: true, name: 'manager', store, dynamic: true })
class ManagerModule extends VuexModule {
  public managers: User[] | [] = [];
  public paging: Paging | null = null;

  @MutationAction({ mutate: ['managers', 'paging'], rawError: true })
  async loadManager(params?: {
    search_key?: string;
    order_by?: string;
    offset?: number;
    limit?: number;
  }) {
    const response = await managerService.loadManager(params);
    return { managers: response.managers, paging: response.paging };
  }

  @MutationAction({ mutate: ['managers', 'paging'], rawError: true })
  async updateManager(managers: User[] | [], paging: Paging | null) {
    return { managers: managers, paging: paging };
  }
}

const managerModule = getModule(ManagerModule);
export default managerModule;
